import { Pipe, PipeTransform } from '@angular/core';

const typeLink = {
	'plan_view': object => {
		return object.map(link => ({
			link: ['plan', 'view', link.plan_id],
			value: link.value
		}));
	},
	'plan_edit': object => {
		return object.map(link => ({
			link: ['plan', 'edit', link.plan_id],
			value: link.value
		}));
	},
	'planogram_view': object => {
		return object.map(link => ({
			link: ['stand', 'view', link.planogram_id],
			value: link.value,
			params: { planogram: link.plan_id }
		}));
	},
	'planogram_edit': object => {
		return object.map(link => ({
			link: ['stand', 'edit', link.planogram_id],
			value: link.value,
			params: { planogram: link.plan_id }
		}));
	},
	'instrument_view': object => {
		return object.map(link => ({
			link: ['equipment', 'view', link.instrument_id],
			value: link.value
		}));
	},
	'instrument_edit': object => {
		return object.map(link => ({
			link: ['equipment', 'edit', link.instrument_id],
			value: link.value
		}));
	},
	'execution': object => {
		return object.map(link => ({
			link: ['notifications', `${link.planogram_id_on_plan},${link.planogram_id}`],
			value: link.value,
			params: { planogram: link.plan_id }
		}));
	},
	'product': object => {
		return object.map(link => ({
			link: ['product'],
			value: link.value,
			params: { id: link.product_id }
		}));
	}
};

@Pipe({
    name: 'linkType',
    standalone: true
})
export class LinkTypePipe implements PipeTransform {

	transform(link: any, type: string): Array<{ value: string, link: Array<string | number>, params?: any }>{
		return typeLink[type](link);
	}
}
